import {
  ArrowDownTrayIcon,
  Button,
  useToaster
} from "@dealer-center/core-components";
import { TagManager } from "@dealer-center/core-third-party-gtm";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { bulkFetch } from "@dealer-center/ddc-pages-account-search-fetch";
import styled from "styled-components";
import { useContext } from "react";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
import {
  lambdaError,
  lambdaTimeoutError
} from "@dealer-center/ddc-pages-account-search-interface";

const StyledButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  svg {
    height: 18px;
  }
`;
const StyledArrowDownTrayIcon = styled(ArrowDownTrayIcon)`
  margin-right: 4px;
`;

export const PagesClientSearchBulk = () => {
  const { toastError, toastSuccess, toastInfo } = useToaster();
  const toastTitle = "Result Download";
  const { searchRequest } = useContext(AccountSearchContext);
  const flags = useCC9Flags();
  const { "cc9-client-search.show-download": shouldShowDownload } = flags;
  const downloadResultsClicked = async () => {
    TagManager.event({
      eventName: "Client Search Download Results",
      eventProperties: {
        component: "client-search"
      }
    });
    toastInfo(toastTitle, "Preparing results...");
    try {
      const results = await bulkFetch(searchRequest);
      if (results === lambdaTimeoutError) {
        toastError("Request is too large");
        return;
      } else if (results === lambdaError) {
        toastError("Failed to download results");
        return;
      } else {
        toastSuccess(toastTitle, "Results ready for download");
        const blob = new Blob([results], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = "results.csv";
        link.href = url;
        link.click();
      }
    } catch (e) {
      console.error(e);
      toastError("Failed to download results");
    }
  };
  if (!shouldShowDownload) return null;
  return (
    <StyledButton
      analyticsConfiguration={{
        eventName: "Client Search Download Results"
      }}
      buttonStyle="aux"
      size="small"
      onClick={downloadResultsClicked}
    >
      <StyledArrowDownTrayIcon title="Download" />
      Download
    </StyledButton>
  );
};
